import { render, staticRenderFns } from "./NoViable.vue?vue&type=template&id=71984fac"
import script from "./NoViable.vue?vue&type=script&lang=js"
export * from "./NoViable.vue?vue&type=script&lang=js"
import style0 from "./NoViable.vue?vue&type=style&index=0&id=71984fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports